/* Full reviews: a clamped testimonial gets «Les hele»; a dialog shows one review at a time with arrows.
   Works with the slider (clones share data-index) and without JavaScript the clamped text simply stays short. */
(() => {
  const decorate = section => {
    section.querySelectorAll('.testimonial__content').forEach(text => {
      if (text.dataset.reviewChecked === String(window.innerWidth)) return;
      text.dataset.reviewChecked = String(window.innerWidth);
      // Compare the natural height with the clamped one: sub-pixel differences (an emoji's taller line box)
      // must not count, and texts that fit lose the clamp so no stray «…» is drawn.
      text.classList.remove('is-full');
      const shown = text.getBoundingClientRect().height;
      text.classList.add('is-measuring');
      const natural = text.getBoundingClientRect().height;
      text.classList.remove('is-measuring');
      const clamped = natural > shown + 4;
      text.classList.toggle('is-clamped', clamped);
      text.classList.toggle('is-full', !clamped);
      let more = text.nextElementSibling?.classList.contains('ll-review-more') ? text.nextElementSibling : null;
      if (clamped && !more) {
        more = document.createElement('button');
        more.type = 'button';
        more.className = 'll-review-more';
        more.setAttribute('aria-haspopup', 'dialog');
        more.textContent = 'Les hele';
        text.after(more);
      }
      if (more) more.hidden = !clamped;
    });
  };

  const setup = section => {
    const dialog = section.querySelector('.ll-review-dialog');
    if (!dialog || dialog.dataset.ready) return;
    dialog.dataset.ready = 'true';
    const body = dialog.querySelector('[data-review-body]');
    const count = dialog.querySelector('[data-review-count]');
    // One entry per review, in section order (slider clones share data-index).
    const reviews = [];
    section.querySelectorAll('[data-index]').forEach(slide => {
      const i = Number(slide.dataset.index);
      if (!reviews[i]) reviews[i] = slide.querySelector('.testimonial');
    });
    const list = reviews.filter(Boolean);
    let current = 0;
    let opener = null;
    const render = () => {
      const card = list[current];
      body.replaceChildren();
      ['.testimonial__name', '.testimonial__icon', '.testimonial__content'].forEach(selector => {
        const node = card.querySelector(selector);
        if (node) body.append(node.cloneNode(true));
      });
      const product = card.querySelector('.testimonial__product');
      if (product) {
        const link = product.cloneNode(true);
        link.removeAttribute('target');
        body.append(link);
      }
      body.querySelector('.testimonial__content')?.classList.remove('is-clamped');
      count.textContent = `${current + 1} av ${list.length}`;
      body.scrollTop = 0;
    };
    const step = delta => { current = (current + delta + list.length) % list.length; render(); };
    section.addEventListener('click', event => {
      const target = event.target instanceof Element ? event.target.closest('.ll-review-more, .testimonial__content.is-clamped') : null;
      if (!target) return;
      const slide = target.closest('[data-index]');
      const card = slide?.querySelector('.testimonial');
      const index = list.indexOf(reviews[Number(slide?.dataset.index)] || card);
      current = index >= 0 ? index : 0;
      opener = target.classList.contains('ll-review-more') ? target : target.nextElementSibling;
      render();
      dialog.showModal();
      dialog.querySelector('.ll-review-dialog__close')?.focus({ preventScroll: true });
    });
    dialog.querySelector('[data-review-prev]')?.addEventListener('click', () => step(-1));
    dialog.querySelector('[data-review-next]')?.addEventListener('click', () => step(1));
    dialog.querySelector('.ll-review-dialog__close')?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); step(-1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); step(1); }
    });
    // A click on the dimmed area outside the panel closes it.
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => opener?.focus({ preventScroll: true }));
    if (list.length < 2) dialog.querySelector('.ll-review-dialog__nav')?.setAttribute('hidden', '');
  };

  const run = () => document.querySelectorAll('.testimonials-wrapper').forEach(section => { setup(section); decorate(section); });
  const ready = () => {
    run();
    (document.fonts?.ready || Promise.resolve()).then(run);
    window.addEventListener('load', run, { once: true });
    let timer;
    window.addEventListener('resize', () => { clearTimeout(timer); timer = setTimeout(run, 200); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();
